// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
// Figma: paperBackground/option share Menu/* component color tokens
// (Menu/Background, Menu/Text, Menu/Hover/Background, Menu/Active/Background,
// Menu/Active+Hover/Background)
export var autocompleteColors = function(mode) {
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        // Figma: dropdown carat and clear icon share Select Box/Default/Icon
        dropdownIcon: ic.heavy,
        clearIndicator: ic.heavy,
        // Figma: No Results variant text uses the same color as Menu/Disabled/Text
        noOptions: tx.disabled,
        paperBackground: bg.template.dialogs,
        option: {
            text: tx.primary,
            hoverBackground: bg.state.hover0,
            selectedBackground: bg.state.selectedTransparent,
            selectedHoverBackground: bg.state.selectedTransparent2
        }
    };
};

//# sourceMappingURL=autocompleteColors.js.map